export default {
  title: 'HLR',

  labels: {
    search: 'Enter phone number',
    status: 'Search status'
  }
}
